import { ENVIRONMENTAL_STATUS_WIDGET_TYPE } from '../../../widgets/environmentalStatusConfig';
import { ASSET_STATUS_WIDGET_TYPE, STATUS_ARROW_WIDGET_TYPE } from '../../../widgets/assetStatusUtils';
import { getWaterNetworkMinDimensions } from '../../../utils/waterNetworkLayout';

export const EDITABLE_TRAILING_ROWS = 2;
export const WATER_TANK_WIDGET_TYPE = 'water-tank';
export const HIDDEN_WIDGET_EDITOR_PROP_KEYS = new Set([
  'themeMode',
  'freeMovement',
  'linkToNearby',
]);
export const VALUE_COLOR_WIDGET_TYPES = [
  'gauge',
  'liquid',
  WATER_TANK_WIDGET_TYPE,
  'radial-gauge',
  'label',
];
export const DATASTREAM_COLOR_WIDGET_TYPES = [
  ...VALUE_COLOR_WIDGET_TYPES,
  'led',
  'number',
  'slider',
  'switch',
  'push-button',
  'segment-switch',
  'text-title',
  STATUS_ARROW_WIDGET_TYPE,
];
export const SHOW_UNIT_WIDGET_TYPES = [
  'gauge',
  'liquid',
  WATER_TANK_WIDGET_TYPE,
  'radial-gauge',
  'label',
  'number',
];
export const LIQUID_STYLE_PROTECTED_COLOR_KEYS = [
  'cardBackgroundColor',
  'titleColor',
  'valueColor',
  'unitColor',
  'glowColor',
];
export const NUMERIC_VALUE_WIDGET_TYPES = new Set([
  'gauge',
  'radial-gauge',
  'liquid',
  WATER_TANK_WIDGET_TYPE,
  'label',
  'number',
  'slider',
  'led',
  'switch',
  'push-button',
  'pipe',
  'elbow',
  'water-pump',
]);
export const DEFAULT_WIDGET_GRID_GAP = 8;
export const ENVIRONMENTAL_STATUS_MIN_WIDTH = 382;
export const ENVIRONMENTAL_STATUS_MIN_HEIGHT = 155;
export const ASSET_STATUS_DEFAULT_WIDTH = 320;
export const ASSET_STATUS_DEFAULT_HEIGHT = 190;
export const ASSET_STATUS_MIN_WIDTH = 190;
export const ASSET_STATUS_MIN_HEIGHT = 118;
export const STATUS_ARROW_DEFAULT_WIDTH = 260;
export const STATUS_ARROW_DEFAULT_HEIGHT = 120;
export const STATUS_ARROW_MIN_WIDTH = 60;
export const STATUS_ARROW_MIN_HEIGHT = 34;
export const KEYPAD_DEFAULT_WIDTH = 383;
export const KEYPAD_DEFAULT_HEIGHT = 347;
export const KEYPAD_MIN_WIDTH = 240;
export const KEYPAD_MIN_HEIGHT = 280;
export const SEGMENT_SWITCH_DEFAULT_WIDTH = 383;
export const SEGMENT_SWITCH_DEFAULT_HEIGHT = 220;
export const SEGMENT_SWITCH_MIN_WIDTH = 240;
export const SEGMENT_SWITCH_MIN_HEIGHT = 140;
export const TABLE_DEFAULT_WIDTH = 383;
export const TABLE_DEFAULT_HEIGHT = 398;
export const TABLE_MIN_WIDTH = 338;
export const TABLE_MIN_HEIGHT = 275;
export const SLIDER_NUMBER_CONTENT_ALIGNMENT_OPTIONS = [
  { label: 'Auto', value: 'auto' },
  { label: 'Top', value: 'top' },
  { label: 'Center', value: 'center' },
  { label: 'Bottom', value: 'bottom' },
  { label: 'Title Line', value: 'title-line' },
];

export const getSpannedWidgetSize = (
  baseSize,
  spanCount,
  gap = DEFAULT_WIDGET_GRID_GAP
) => (baseSize * spanCount) + (Math.max(0, spanCount - 1) * gap);

export const getMinimumWidgetSizeForType = (type, defaultWidth, defaultHeight) => {
  const waterWidgetMinimum = getWaterNetworkMinDimensions(type);
  if (waterWidgetMinimum) {
    return waterWidgetMinimum;
  }

  if (type === ENVIRONMENTAL_STATUS_WIDGET_TYPE) {
    return {
      width: ENVIRONMENTAL_STATUS_MIN_WIDTH,
      height: ENVIRONMENTAL_STATUS_MIN_HEIGHT,
    };
  }

  if (type === ASSET_STATUS_WIDGET_TYPE) {
    return {
      width: ASSET_STATUS_MIN_WIDTH,
      height: ASSET_STATUS_MIN_HEIGHT,
    };
  }

  if (type === STATUS_ARROW_WIDGET_TYPE) {
    return {
      width: STATUS_ARROW_MIN_WIDTH,
      height: STATUS_ARROW_MIN_HEIGHT,
    };
  }

  if (type === 'keypad') {
    return {
      width: KEYPAD_MIN_WIDTH,
      height: KEYPAD_MIN_HEIGHT,
    };
  }

  if (type === 'segment-switch') {
    return {
      width: SEGMENT_SWITCH_MIN_WIDTH,
      height: SEGMENT_SWITCH_MIN_HEIGHT,
    };
  }

  if (type === 'table') {
    return {
      width: TABLE_MIN_WIDTH,
      height: TABLE_MIN_HEIGHT,
    };
  }

  return {
    width: defaultWidth,
    height: defaultHeight,
  };
};

export const getDefaultWidgetDimensions = (type, defaultWidth, defaultHeight) =>
  type === WATER_TANK_WIDGET_TYPE
    ? { width: defaultWidth, height: defaultWidth }
      : type === ENVIRONMENTAL_STATUS_WIDGET_TYPE
        ? {
            width: ENVIRONMENTAL_STATUS_MIN_WIDTH,
            height: ENVIRONMENTAL_STATUS_MIN_HEIGHT,
          }
        : type === ASSET_STATUS_WIDGET_TYPE
          ? {
              width: ASSET_STATUS_DEFAULT_WIDTH,
              height: ASSET_STATUS_DEFAULT_HEIGHT,
            }
          : type === STATUS_ARROW_WIDGET_TYPE
            ? {
                width: STATUS_ARROW_DEFAULT_WIDTH,
                height: STATUS_ARROW_DEFAULT_HEIGHT,
              }
      : type === 'keypad'
        ? {
            width: KEYPAD_DEFAULT_WIDTH,
            height: KEYPAD_DEFAULT_HEIGHT,
          }
        : type === 'segment-switch'
          ? {
              width: SEGMENT_SWITCH_DEFAULT_WIDTH,
              height: SEGMENT_SWITCH_DEFAULT_HEIGHT,
            }
          : type === 'table'
            ? {
                width: TABLE_DEFAULT_WIDTH,
                height: TABLE_DEFAULT_HEIGHT,
              }
            : { width: defaultWidth, height: defaultHeight };

export const isHiddenWidgetEditorPropKey = (key) =>
  HIDDEN_WIDGET_EDITOR_PROP_KEYS.has(key) || String(key || '').endsWith('Light');
